var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg15Roudou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9E1284;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_1_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_2_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_3_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_4_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_5_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_6_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_7_"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_8_"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_9_"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_10_"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_11_"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_12_"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_13_"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D_14_"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 24,
    cy: 26,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 14,
    cy: 26,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5,
    cy: 5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,22h-2v-6h-2v-6H14v6h-2v-6h-2v1H8V8H6H5H4H2v20h2v-8h2v8h2v-8v-2h2v4v2h4h10h4V22z M8,16v-3h2v3H8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15Roudou);
export default __webpack_public_path__ + "static/media/15_roudou.ce2cef7d684f91fb23c3063285fc2dd9.svg";
export { ForwardRef as ReactComponent };